module.exports = __webpack_public_path__ + "static/media/advisoryboard12.0cd98adc.jpeg";